import styles from '../../../../styles/purchaseInvoices/pages/invoiceUploaderStyle';
import { useInvoiceUploader } from '../../../../hooks/purchaseInvoices/pages/InvoiceUploaderHook';
import DropZone from '../../../../components/purchaseInvoices/invoiceManagement/InvoiceUploader/DropZone';
import PendingFilesList from '../../../../components/purchaseInvoices/invoiceManagement/InvoiceUploader/PendingFilesList';
import UploadedFilesList from '../../../../components/purchaseInvoices/invoiceManagement/InvoiceUploader/UploadedFilesList';
import { FileUp } from 'lucide-react';
import translations from '../../../../translations/PurchaseInvoiceTranslation';

const InvoiceUploader = ({ onClose }) => {
  const {
    isDragging,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleClick,
    fileInputRef,
    handleFileInput,
    files,
    uploadedFiles,
    isUploading,
    simulateUpload,
    uploadStatus,
    removeFile,
    uploadProgress,
    uploadStage,
  } = useInvoiceUploader();

  return (
    <div style={{ position: 'relative', minHeight: '100%' }}>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes floatSlow {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
          }
        `}
      </style>

      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
        zIndex: 0
      }}>
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              width: '8px',
              height: '8px',
              background: `rgba(59, 130, 246, ${0.15 + (i % 3) * 0.05})`,
              borderRadius: '50%',
              left: `${10 + i * 11}%`,
              top: `${20 + (i % 4) * 20}%`,
              animation: `floatSlow ${5 + i}s ease-in-out infinite`,
              animationDelay: `${i * 0.5}s`
            }}
          ></div>
        ))}
      </div>

      <div style={{ ...styles.container, position: 'relative', zIndex: 1 }}>
        {onClose && (
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '16px',
              left: '16px',
              background: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              zIndex: 10,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.1)';
              e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
        
        <div style={{
          marginBottom: '32px',
          textAlign: 'center',
          animation: 'fadeIn 0.6s ease-out'
        }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            marginBottom: '8px'
          }}>
            <div style={{
              backgroundColor: '#dbeafe',
              padding: '12px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(59, 130, 246, 0.15)'
            }}>
              <FileUp size={28} style={{ color: '#3b82f6' }} />
            </div>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#1e293b',
              margin: 0
            }}>
              {translations.invoiceManagement || 'ניהול חשבוניות'}
            </h2>
          </div>
          <p style={{
            fontSize: '0.875rem',
            color: '#64748b',
            margin: 0
          }}>
            העלאה וניהול חשבוניות רכש בקלות
          </p>
        </div>

        <div style={styles.grid}>
          <DropZone
            isDragging={isDragging}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onClick={handleClick}
            fileInputRef={fileInputRef}
            onFileInput={handleFileInput}
            styles={styles}
          />
        </div>

        <PendingFilesList
          files={files}
          onRemove={removeFile}
          onUpload={simulateUpload}
          isUploading={isUploading}
          uploadProgress={uploadProgress}
          uploadStatus={uploadStatus}
          uploadStage={uploadStage}
          styles={styles}
        />

        <UploadedFilesList files={uploadedFiles} styles={styles} />
      </div>
    </div>
  );
};

export default InvoiceUploader;